module.exports = __webpack_public_path__ + "img/GoldYellowPattern.bcf44d9e.svg";